import { isNil } from 'lodash-es'

import { cn } from '@/shared/lib'

export type DiscountBadgeProps = {
  percent: number
  amount: number
  className?: string
}

const LongTermDiscount = ({ percent }: Pick<DiscountBadgeProps, 'percent'>) => (
  <p className="typo-caption1 shrink-0 text-black">
    <span className="mr-1 font-normal">장기계약 최대</span>
    <span className="mr-0.5 font-bold">{percent}%</span>
    <span className="font-bold text-purple-500">할인</span>
  </p>
)

const EarlyDiscount = ({ amount }: Pick<DiscountBadgeProps, 'amount'>) => (
  <p className="typo-caption1 shrink-0 text-black">
    <span className="mr-1 font-normal">즉시입주 최대</span>
    <span className="mr-0.5 font-bold">{amount}만 원</span>
    <span className="font-bold text-purple-500">할인</span>
  </p>
)

const Separator = () => (
  <span className="text-[12px] leading-[15px] font-extralight tracking-[-0.1px] text-purple-300">
    ㅣ
  </span>
)

export const MobileDiscountBadge = ({
  percent,
  amount,
  className,
}: DiscountBadgeProps) => {
  if (isNil(percent) || isNil(amount)) {
    return null
  }

  if (!(percent || amount)) {
    return null
  }

  const hasLongTermDiscount = Boolean(percent)
  const hasEarlyDiscount = Boolean(amount)

  return (
    <div
      className={cn(
        'flex h-7 w-full items-center justify-center space-x-1 rounded-sm bg-gray-50 px-2.5 py-2',
        className,
      )}
    >
      {hasLongTermDiscount && <LongTermDiscount percent={percent} />}
      {hasLongTermDiscount && hasEarlyDiscount && <Separator />}
      {hasEarlyDiscount && <EarlyDiscount amount={amount} />}
    </div>
  )
}
